export default {
  name: 'RosterParentEmails',
  props: ['project', 'errors', 'form'],
  destroyed() {
    this.form.opt_out = null;
  }
};